import { render } from "./Characters.vue?vue&type=template&id=634ad686&scoped=true"
import script from "./Characters.vue?vue&type=script&lang=js"
export * from "./Characters.vue?vue&type=script&lang=js"

import "./Characters.vue?vue&type=style&index=0&id=634ad686&scoped=true&lang=css"

import exportComponent from "C:\\0_PROJECTS\\EcoSim\\Csongrad\\sar_es_tuz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634ad686"]])

export default __exports__